// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2v4Wm","pop-up":"Footer_pop-up__7KYaL","funded-btn":"Footer_funded-btn__2tEmQ","info-image":"Footer_info-image__nEOml"};